import { scoreConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  init: false,
  me: null,
  list: null,
  success: false
}

export default function score(state = initialState, action) {
  switch (action.type) {
    case scoreConstants.SCORE_LOAD:
      return {
        ...state,
        loading: true,
        init: true
      }
    case scoreConstants.SCORE_LOAD_SUCCESS:
      return {
        ...state,
        list: action.payload.list,
        loading: false
      }
    case scoreConstants.SCORE_LOAD_FAILURE:
    case scoreConstants.SCORE_SAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      }
    case scoreConstants.SCORE_SAVE:
      return {
        ...state,
        me: action.payload,
        loading: true
      }
    case scoreConstants.SCORE_SAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        me: action.payload,
        success: true
      }
    case scoreConstants.SCORE_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
